import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"


interface Props {
  active:boolean
}

export default /*#__PURE__*/_defineComponent({
  props: {
    active: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["border py-2 pl-6 flex items-center rounded-lg cursor-pointer transition-colors hover:text-permaGreen11 hover:border-permaGreen11 hover:bg-permaGreen6", __props.active ? 'text-permaGreen4 border-permaGreen4 bg-permaGreen6' : ' border-white border-opacity-70 text-white text-opacity-70'])
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})